import React from "react";
import {TableContentWithoutEdit} from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const contentRowNames = this.props.rowNames;
        const reportData = this.props.data;

        return (
            <div>
                <h3 className="pr-2"><center><u>Subordinates Weighment Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Esate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                 </div>
                <div className="table-responsive row-top-gap">
                    <table id="blockWeighment" className="display dataTable no-footer">
                        <thead>
                            <tr>
                                <th>Employee Name</th>
                                <th>Registration Number</th>
                                <th>Subordian Code</th>
                                <th>Subordian Name</th>
                                <th>Actual Amount</th>
                                <th>Gross sAmount</th>
                                <th>Net Amount</th>
                                <th>Total Deduction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <TableContentWithoutEdit
                                data={reportData}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}